import { Axios } from '@/config/axios'
import axios from 'axios'

const state = {
    showFeedBackInstall: false,
    adminOhpEuid: null
}

const getters = {
    isShowFeedBackInstall (state) {
        return state.isShowFeedBackInstall
    },
    getAdminOhpEuid (state) {
        return state.adminOhpEuid
    }
}

const actions = {
    getConfigurationsInfo ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/configurations?ohpEuid=${data.adminOhpEuid}`).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },
    updateContactEmail ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.put(`/api/configuration/contact-email`, data).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },
    updateRequiredInfo ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.put(`/api/configuration/customer-required-info`, data).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },
    isContactEmailConfigured ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/configuration/is-email-contact-validated`, data).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },
    sendMetric ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(`/api/metrics`, data).then((response) => {
                resolve(response.data.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },

    fetchSirenInfo ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/sirene/siren/${data.siren}`).then((response) => {
                resolve(response.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    },

    fetchSiretInfo ({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`/api/sirene/siret/${data.siret}`).then((response) => {
                resolve(response.data)
            })
                .catch(function (error) {
                    reject(error.response)
                })
        })
    }
}

const mutations = {
    updateShowFeedBackInstall (state, value) {
        state.showFeedBackInstall = value
    },
    updateAdminOhpEuid (state, value) {
        state.adminOhpEuid = value
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
